import { render, staticRenderFns } from "./jingjiren.vue?vue&type=template&id=6cadef36&scoped=true&"
import script from "./jingjiren.vue?vue&type=script&lang=js&"
export * from "./jingjiren.vue?vue&type=script&lang=js&"
import style0 from "./jingjiren.vue?vue&type=style&index=0&id=6cadef36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cadef36",
  null
  
)

export default component.exports